module.exports = __webpack_public_path__ + "static/img/soft_2.3ea9768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_2.png
// module id = /Bcc
// module chunks = 0